<meeting-scheduler-calendar-slug-card
  [calendarId]="personalCalendarId$ | async"
  [setInitial]="false"
  [disableButtonIfValueUnchanged]="true"
  [showHeaderIcon]="true"
></meeting-scheduler-calendar-slug-card>

<meeting-scheduler-settings-calendar-card
  *ngIf="(featureMicrosoftTeamsEnabled$ | async) === true"
  (calendarProviderSelected)="handleCalendarProvider($event)"
>
  <mat-card-actions class="action-cont">
    <div class="stepper-actions-column">
      <meeting-scheduler-connect-with-microsoft-button
        *ngIf="selectedCalendarProvider === 'microsoft' && (featureMicrosoftTeamsEnabled$ | async) === true"
        [serviceKey]="SERVICE_KEYS.eventsAndMeetingsPageCalendarConnected"
        [primaryDisconnect]="false"
      ></meeting-scheduler-connect-with-microsoft-button>
      <meeting-scheduler-connect-with-google-button
        *ngIf="selectedCalendarProvider === 'google'"
        [serviceKey]="SERVICE_KEYS.eventsAndMeetingsPageCalendarConnected"
        [primaryDisconnect]="false"
      ></meeting-scheduler-connect-with-google-button>
    </div>
  </mat-card-actions>
</meeting-scheduler-settings-calendar-card>
<meeting-scheduler-settings-calendar-card *ngIf="(featureMicrosoftTeamsEnabled$ | async) === false">
  <mat-card-actions class="action-cont">
    <div class="stepper-actions-column">
      <meeting-scheduler-connect-with-microsoft-button
        *ngIf="(featureMicrosoftTeamsEnabled$ | async) === true"
        [serviceKey]="SERVICE_KEYS.eventsAndMeetingsPageCalendarConnected"
        [primaryDisconnect]="false"
      ></meeting-scheduler-connect-with-microsoft-button>
      <meeting-scheduler-connect-with-google-button
        [serviceKey]="SERVICE_KEYS.eventsAndMeetingsPageCalendarConnected"
        [primaryDisconnect]="false"
      ></meeting-scheduler-connect-with-google-button>
    </div>
  </mat-card-actions>
</meeting-scheduler-settings-calendar-card>

<meeting-scheduler-settings-meeting-app-card
  [serviceKey]="SERVICE_KEYS.eventsAndMeetingsPageConferencingConnected"
  [hostPreferences]="hostPreferences"
  [isGoogleMeetConfigured]="isGoogleMeetConfigured"
  [isMicrosoftConfigured]="isMicrosoftConfigured"
>
  <mat-card-actions class="meeting-app-actions">
    <button *ngIf="integrationsPageLink$ | async as link" [routerLink]="[link]" mat-raised-button color="primary">
      Open integration settings
    </button>
  </mat-card-actions>
</meeting-scheduler-settings-meeting-app-card>

<meeting-scheduler-settings-availability-increment-card
  [preferredAvailabilityIncrement]="hostPreferences?.availabilityIncrement"
></meeting-scheduler-settings-availability-increment-card>

<meeting-scheduler-settings-meeting-before-buffer-card
  *ngIf="(featureMeetingBeforeBufferEnabled$ | async) === true"
  [bufferDurationBeforeMeeting]="hostPreferences?.bufferDurationBeforeMeeting"
></meeting-scheduler-settings-meeting-before-buffer-card>

<meeting-scheduler-settings-meeting-buffer-card
  [bufferDurationAfterMeeting]="hostPreferences?.bufferDurationAfterMeeting"
></meeting-scheduler-settings-meeting-buffer-card>

<meeting-scheduler-settings-notice-time-card
  [noticeTime]="hostPreferences?.noticeTime"
></meeting-scheduler-settings-notice-time-card>

<meeting-scheduler-settings-advanced-availability-card
  [timezone]="hostPreferences?.timezone.id"
  currentView="settings"
></meeting-scheduler-settings-advanced-availability-card>
